import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { value: "" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 1,
  class: "scrollListContainer"
}
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, _toDisplayString(_ctx.config.label.values[_ctx.$store.state.selectedLanguage]), 1),
    (_ctx.config.isSelect)
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 0,
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue[0]) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitModel(_ctx.localValue)))
        }, [
          _createElementVNode("option", _hoisted_2, [
            _createVNode(_component_localized_text, {
              localizedKey: "Seleziona una risposta",
              text: "Seleziona una risposta"
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (item, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: item.values[_ctx.$store.state.selectedLanguage]
            }, _toDisplayString(item.values[_ctx.$store.state.selectedLanguage]), 9, _hoisted_3))
          }), 128))
        ], 544)), [
          [_vModelSelect, _ctx.localValue[0]]
        ])
      : (_ctx.config.isMultiSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (item, i) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "scrollListItem pointer d-flex align-items-center",
                key: i
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check",
                  value: item.values[_ctx.$store.state.selectedLanguage],
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue) = $event)),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitModel(_ctx.localValue)))
                }, null, 40, _hoisted_5), [
                  [_vModelCheckbox, _ctx.localValue]
                ]),
                _createTextVNode(" " + _toDisplayString(item.values[_ctx.$store.state.selectedLanguage]), 1)
              ]))
            }), 128))
          ]))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 2,
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue[0]) = $event)),
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitModel(_ctx.localValue)))
          }, null, 544)), [
            [_vModelText, _ctx.localValue[0]]
          ])
  ]))
}